(function(){
  var doc=document,html=doc.documentElement;
  var lc=(html.lang||'fr').slice(0,2);
  var T=lc==='fr'?{err:"Impossible d'ajouter ce produit.",max:'Quantité maximale atteinte.'}:{err:'Unable to add this product.',max:'Maximum quantity reached.'};
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var drawer=doc.querySelector('[data-cdr]');
  var lastFocus=null,isOpen=false;
  var VSEL='.card__qa select, .cdr__sgform select, .feat__qa select';
  function q(s,r){return (r||doc).querySelector(s);}
  function qa(s,r){return Array.prototype.slice.call((r||doc).querySelectorAll(s));}
  function base(u){return String(u||'').split('?')[0];}
  /* Photo de la variante choisie : cartes, tiroir panier, produit en vedette */
  function swapFor(s,quiet){
    var oc=s.options[s.selectedIndex],wrap=s.closest('.card, .cdr__sg, .feat');
    if(!oc||!wrap)return;
    var img=wrap.querySelector('.card__media img, .cdr__sgimg img, .feat__media img');
    if(!img)return;
    if(!img.dataset.o){img.dataset.o=img.getAttribute('src')||'';img.dataset.os=img.getAttribute('srcset')||'';}
    var u=oc.getAttribute('data-img');
    if(u){
      if(base(img.getAttribute('src'))!==base(u)){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=u;}
    }else{
      img.src=img.dataset.o;
      if(img.dataset.os){img.setAttribute('srcset',img.dataset.os);}
    }
    if(!quiet){var tr=wrap.querySelector('[data-card-track]');if(tr){tr.scrollTo({left:0,behavior:'smooth'});}}
  }
  function syncSelects(scope){qa(VSEL,scope).forEach(function(s){swapFor(s,true);});}
  /* Fiche produit : la photo de la variante choisie passe en premier dans la galerie */
  function galleryFirst(mid,smooth){
    var gal=q('.gallery');if(!gal||!mid)return;
    var it=q('.gallery__item[data-media-id="'+mid+'"]',gal);if(!it)return;
    if(it!==gal.firstElementChild){gal.insertBefore(it,gal.firstElementChild);}
    if(gal.scrollTo){gal.scrollTo({left:0,top:0,behavior:smooth?'smooth':'auto'});}
  }
  function fixTypo(node){
    if(lc!=='fr'||!node)return;
    var w=doc.createTreeWalker(node,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var p=n.parentNode;if(!p)return NodeFilter.FILTER_REJECT;
      var t=p.nodeName;
      if(t==='SCRIPT'||t==='STYLE'||t==='TEXTAREA'||t==='PRE'||t==='CODE'||t==='NOSCRIPT')return NodeFilter.FILTER_REJECT;
      return / [?!:;»]|« /.test(n.nodeValue)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;
    }});
    var list=[];while(w.nextNode())list.push(w.currentNode);
    list.forEach(function(n){n.nodeValue=n.nodeValue.replace(/ ([?!:;»])/g,' $1').replace(/« /g,'« ');});
  }
  function setCount(n){n=Number(n)||0;qa('[data-cart-count]').forEach(function(e){e.textContent=n;e.hidden=!(n>0);});}
  /* Compteur toujours juste : relit le vrai panier (cart.js) */
  var cseq=0;
  function syncCount(){
    var my=++cseq;
    return fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){if(my===cseq&&c&&typeof c.item_count==='number'){setCount(c.item_count);}})
      .catch(function(){});
  }
  function drawerMsg(t){var m=q('[data-cdr-msg]',drawer);if(!m)return;m.textContent=t||'';m.hidden=!t;}
  function openDrawer(){
    if(!drawer||isOpen)return;
    isOpen=true;lastFocus=doc.activeElement;
    drawer.hidden=false;html.classList.add('cdr-open');
    requestAnimationFrame(function(){requestAnimationFrame(function(){drawer.classList.add('is-open');});});
    var p=q('.cdr__panel',drawer);if(p)p.focus();
  }
  function closeDrawer(){
    if(!drawer||!isOpen)return;
    isOpen=false;drawer.classList.remove('is-open');html.classList.remove('cdr-open');
    setTimeout(function(){if(!isOpen)drawer.hidden=true;},260);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  /* Une seule réponse gagne : la plus récente (évite qu'une vieille réponse écrase le compteur) */
  var rseq=0;
  function refresh(){
    var my=++rseq;
    return fetch(root+'?sections=cart-drawer',{credentials:'same-origin',cache:'no-store'}).then(function(r){if(!r.ok)throw new Error('sections');return r.json();}).then(function(d){
      if(my!==rseq)return;
      var tmp=doc.createElement('div');tmp.innerHTML=d['cart-drawer']||'';
      var ni=q('[data-cdr-inner]',tmp),oi=q('[data-cdr-inner]',drawer);
      if(!ni||!oi)throw new Error('markup');
      oi.innerHTML=ni.innerHTML;
      var n=Number(ni.getAttribute('data-count'))||0;
      oi.setAttribute('data-count',n);setCount(n);
      fixTypo(oi);syncSelects(oi);
    });
  }
  function formMsg(form,text){
    var p=form.nextElementSibling;
    if(!p||!p.classList.contains('qa-msg')){p=doc.createElement('p');p.className='qa-msg';p.setAttribute('role','alert');form.parentNode.insertBefore(p,form.nextSibling);}
    p.textContent=text;
    setTimeout(function(){if(p&&p.parentNode)p.parentNode.removeChild(p);},5000);
  }
  function addToCart(form){
    var btn=form.querySelector('[type="submit"]');
    var was=btn?btn.disabled:false;
    if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true');}
    var added=false;
    return fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok){formMsg(form,(res.j&&(res.j.description||res.j.message))||T.err);return;}
        added=true;
        return refresh().then(function(){drawerMsg('');openDrawer();},function(){
          /* Le produit EST ajouté : on remet le compteur à jour et on ouvre la page panier au lieu d'afficher une fausse erreur */
          return syncCount().then(function(){window.location.href=root+'cart';});
        });
      })
      .catch(function(){if(added){syncCount();}else{formMsg(form,T.err);}})
      .then(function(){if(btn){btn.disabled=was;btn.removeAttribute('aria-busy');}});
  }
  var qtyBusy=false;
  function changeQty(key,qty){
    if(qtyBusy)return Promise.resolve();
    qtyBusy=true;
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok){
          var d=(res.j&&(res.j.description||res.j.message))||'';
          var stale=!d||/identifiant|valid id|line|ligne/i.test(d);
          return refresh().then(function(){drawerMsg(stale?'':d);});
        }
        drawerMsg('');
        return refresh();
      })
      .catch(function(){return refresh().catch(function(){return syncCount();});})
      .then(function(){qtyBusy=false;});
  }
  doc.addEventListener('submit',function(e){
    var f=e.target;
    if(!drawer||!f||!f.matches||!f.matches('form[action*="/cart/add"]'))return;
    if(doc.body.classList.contains('template-cart'))return;
    e.preventDefault();addToCart(f);
  });
  doc.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    var qb=t.closest('[data-cdr-qty]');
    if(qb){e.preventDefault();changeQty(qb.getAttribute('data-cdr-qty'),Number(qb.getAttribute('data-q')));return;}
    if(t.closest('[data-cdr-close]')){e.preventDefault();closeDrawer();return;}
    var op=t.closest('[data-cart-open]');
    if(op&&drawer&&!doc.body.classList.contains('template-cart')){e.preventDefault();refresh().then(openDrawer,function(){window.location.href=op.getAttribute('href')||(root+'cart');});return;}
    var cb=t.closest('[data-card-dir]');
    if(cb){
      e.preventDefault();e.stopPropagation();
      var media=cb.closest('.card__media, .feat__media'),track=media&&media.querySelector('[data-card-track]');
      if(!track)return;
      var n=track.children.length,w=track.clientWidth||1;
      var i=Math.max(0,Math.min(n-1,Math.round(track.scrollLeft/w)+Number(cb.getAttribute('data-card-dir'))));
      track.scrollTo({left:i*w,behavior:'smooth'});
    }
  });
  doc.addEventListener('keydown',function(e){
    if(!isOpen)return;
    if(e.key==='Escape'){closeDrawer();return;}
    if(e.key==='Tab'){
      var f=qa('a[href],button:not([disabled]),input,select,textarea,[tabindex="0"]',q('.cdr__panel',drawer)).filter(function(x){return x.offsetParent!==null;});
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&doc.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&doc.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  var raf=0;
  doc.addEventListener('scroll',function(e){
    var t=e.target;
    if(!t||!t.matches||!t.matches('[data-card-track]'))return;
    cancelAnimationFrame(raf);
    raf=requestAnimationFrame(function(){
      var media=t.closest('.card__media, .feat__media'),dots=media&&media.querySelectorAll('.card__dots span');
      if(!dots||!dots.length)return;
      var i=Math.round(t.scrollLeft/(t.clientWidth||1));
      for(var k=0;k<dots.length;k++){dots[k].classList.toggle('on',k===i);}
    });
  },true);
  doc.addEventListener('change',function(e){
    var s=e.target;
    if(!s||!s.matches)return;
    if(s.matches(VSEL)){swapFor(s,false);return;}
    if(!s.matches('.js-variant'))return;
    var o=s.options[s.selectedIndex];if(!o)return;
    galleryFirst(o.getAttribute('data-media'),true);
    var nf=q('[data-notify]');
    if(nf){nf.hidden=(o.getAttribute('data-available')==='true');}
  });
  var sticky=q('[data-sticky-atc]'),mainBtn=q('[data-product-form] [data-add]');
  if(sticky&&mainBtn&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      var r=en[0];
      sticky.classList.toggle('is-on',!r.isIntersecting&&r.boundingClientRect.top<0);
    },{threshold:0});
    io.observe(mainBtn);
    var sb=q('[data-sticky-btn]',sticky);
    if(sb){sb.addEventListener('click',function(){
      var form=mainBtn.form;if(!form)return;
      if(sticky.getAttribute('data-multi')==='true'){form.scrollIntoView({behavior:'smooth',block:'center'});}
      else if(form.requestSubmit){form.requestSubmit(mainBtn);}
      else{mainBtn.click();}
    });}
  }
  /* Retour arrière (cache du navigateur), changement d'onglet, retour au premier plan : on relit le panier */
  window.addEventListener('pageshow',function(e){if(e.persisted){syncCount();}});
  doc.addEventListener('visibilitychange',function(){if(doc.visibilityState==='visible'){syncCount();}});
  fixTypo(doc.body);
  syncSelects(doc);
  var vs0=q('.js-variant');
  if(vs0&&vs0.options[vs0.selectedIndex]){galleryFirst(vs0.options[vs0.selectedIndex].getAttribute('data-media'),false);}
  syncCount();
})();
